import { ReactNode } from 'react';
import styled from 'styled-components';

import { Box } from '../../../common/ui/Box';
import { theme } from '../../../common/ui/theme';
import { useLubricationChartDropzone } from '../hooks/useLubricationChartDropzone';

const getBorderColor = (props: DropZoneProps) => {
    if (props.isDragReject) {
        return theme.colors.negative.emphasis;
    }

    if (props.isDragAccept || props.isDragActive) {
        return theme.colors.accent.emphasis;
    }

    return 'transparent';
};

const getBackgroundColor = (props: DropZoneProps) => {
    if (props.isDragReject) {
        return theme.colors.negative.background;
    }

    if (props.isDragAccept || props.isDragActive) {
        return theme.colors.accent.background;
    }

    return 'transparent';
};

interface DropZoneProps {
    isDragAccept: boolean;
    isDragReject: boolean;
    isDragActive: boolean;
}

const StyledDropZone = styled(Box)<DropZoneProps>`
    border-style: dashed;
    border-color: ${(props) => getBorderColor(props)};
    border-width: 2px;
    border-radius: ${theme.radii[4]};
    padding: ${theme.space[16]};
    background-color: ${(props) => getBackgroundColor(props)};
    transition: all 0.2s ease-in-out;
    min-height: min(calc(100vh - 300px), 400px);
`;

interface LubricationChartDropZoneProps {
    children: ReactNode;
    onFilesDrop: (files: File[]) => void;
}

export const LubricationChartDropZone = ({ children, onFilesDrop }: LubricationChartDropZoneProps) => {
    const { getRootProps, getInputProps, isDragAccept, isDragReject, isDragActive } =
        useLubricationChartDropzone(onFilesDrop);

    return (
        <StyledDropZone
            {...getRootProps()}
            isDragAccept={isDragAccept}
            isDragReject={isDragReject}
            isDragActive={isDragActive}
        >
            <input {...getInputProps()} />
            {children}
        </StyledDropZone>
    );
};
